import { SafaryManager, } from "./safary";

export const bindSafaryToContext = (  ) => {
	const spinup = async () => {
		const script = document.createElement('script');
		script.async = true;
		script.setAttribute('data-name', 'safary-sdk');
		script.setAttribute('data-product-id', 'prd_nnbqjASu6V');
		script.integrity = "sha256-TP/lQj1IzU9EojxJpHW+PuTRh88TBBM6IbrDJNQWR1E=";
		script.crossOrigin = "anonymous";
		globalThis.document.body.appendChild(script);
		try {
			const safary = new SafaryManager(script);
			const result = safary.setup();
		}
		catch( err ) {
			console.log("<<<<<<<<<=====>>>>>>>>>>>>>>");
		}

	};

	setTimeout(async () => await spinup(), 1000);
}
